import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import usePlanStore from 'store/planStore';
import { getAdvertisers } from '../../../../../../../../api/services/mediaPlanning/offline/advertisers';
import { OFFLINE } from '../../../../../../../../api/services/mediaPlanning/offline/setup';
import prepareSelectData from '../../../utils/prepareSelectData';
import { useError } from '../../../../../common/Errors/ErrorContext/ErrorContext';

const useAdvertisers = (country: string) => {
  const {
    generalInfoState,
    selectedCountryISOCode,
    countryForms,
    selectedCountry,
    setSelectedCountryISOCode,
  } = usePlanStore();

  const { showError } = useError();

  const [isoCode, setIsoCode] = useState<string | null>(selectedCountryISOCode);

  useEffect(() => {
    if (country) {
      setSelectedCountryISOCode(country);
    }
  }, [country, setSelectedCountryISOCode]);

  useEffect(() => {
    setIsoCode(selectedCountryISOCode);
  }, [selectedCountryISOCode]);

  const { data: response, isFetching } = useQuery({
    queryKey: [
      OFFLINE,
      'campaign-types',
      country,
      isoCode,
      countryForms[selectedCountry!]?.targetGroup,
    ],
    queryFn: () => getAdvertisers(isoCode ?? ''),
    enabled: !!isoCode,
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
  });

  const advertisers = response?.data || [];
  const preparedData = prepareSelectData(advertisers);

  return { data: preparedData, isFetching };
};

export default useAdvertisers;
